import { XCircleCrossIcon } from "assests";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { transpercencyLineProgressPercentageColors } from "utils/helper";
import Card from "components/UI/Card";
import CircleProgressBar from "components/UI/CircleProgressBar";
import MapView from "components/Card/MapView";
import UpdateSupplyChainCard from "./UpdateSupplyChainCard";
import useIsDesktop from "hooks/useIsDesktop";
import { useSelector } from "react-redux";

function OrderMapCard({ orderDetailsData, refetch }) {
  const { user, currentWorkspace } = useSelector(
    (state) => state.authenticationSlice,
  );
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const isDesktop = useIsDesktop();
  const { orderId } = useParams();
  const [selectedPackage, setSelectedPackage] = useState("all");
  const [myPreparedMapData, setMyPreparedMapData] = useState([]);
  const preparedData = (tier) => {
    // Get the current data from the orderDetails
    const documents = orderDetailsData?.documents;

    if (!documents) return;

    /**
     * For easy use collect all sub-ters data into
     * and array. Later you can easily find each sub-tiers
     * details by its id.
     */
    const subTierList = [];

    for (let i = 0; i <= 4; i++) {
      const tier = orderDetailsData?.transparency[`tier_${i}`];
      if (Array.isArray(tier)) {
        tier.forEach((item) => {
          subTierList.push(item);
        });
      }
    }

    /**
     * Collect all sub-tiers from the transparancey tier_{i}
     * and store them in a list
     */

    if (orderDetailsData && tier === "all") {
      const myPreaparedData = [];

      if (orderDetailsData.forwarder) {
        const { ship_from, ship_to } = orderDetailsData.forwarder;
        if (ship_from && ship_from.address) {
          myPreaparedData.push({
            address: ship_from.address,
            sub_supplier: { name: ship_from.name || "Departure Port" },
            sub_tier: [{ name: "Forwarder" }],
            is_forwarder_connection: true,
          });
        }

        if (ship_to && ship_to.address) {
          myPreaparedData.push({
            address: ship_to.address,
            sub_supplier: { name: ship_to.name || "Arrival Port" },
            sub_tier: [{ name: "Forwarder" }],
            is_port: true,
            is_forwarder_connection: true,
          });
        }
      }

      for (let i = 0; i <= 4; i++) {
        /**Current sub-supplier data */
        const currentSubTier = orderDetailsData?.transparency[`tier_${i}_sub_suppliers`];
        const currentSubTierSupplier = orderDetailsData?.transparency[`tier_${i}_suppliers`];
        /**
         * ! Until confirmation do not remove bellow code
         * ! Old Method
         * Here is the parrtern to prepare data if we get sub_spplier data as array
         */
        if (currentSubTier && Array.isArray(currentSubTier) && currentSubTier.length > 0) {
          currentSubTier?.forEach((item) => {
            const findedItem = myPreaparedData?.find(
              (preparedItem) => preparedItem?.sub_supplier?.id === item?.sub_supplier?.id,
            );

            if (
              orderDetailsData.forwarder &&
              item?.sub_supplier?.id === orderDetailsData.forwarder.sub_supplier_id
            )
              return;

            const findDocuments = documents?.find(
              (doc) =>
                parseInt(doc?.sub_supplier_id) === item?.sub_supplier?.id &&
                parseInt(doc?.sub_tier_id) === item?.sub_tier?.id,
            );

            if (findedItem) {
              findedItem.sub_tier.push({
                ...item?.sub_tier,
                arrive_date: findDocuments?.arrive_date,
                dispatch_date: findDocuments?.dispatch_date,
                quantity: findDocuments?.quantity,
              });
            } else {
              myPreaparedData.push({
                address: item?.sub_supplier?.address,
                sub_supplier: item?.sub_supplier,
                sub_tier: [
                  {
                    ...item?.sub_tier,
                    arrive_date: findDocuments?.arrive_date,
                    dispatch_date: findDocuments?.dispatch_date,
                    quantity: findDocuments?.quantity,
                  },
                ],
              });
            }
          });
        }

        /**
         * ! Until confirmation do not remove bellow code
         * ! New Method==
         * Here is the parrtern to prepare data if we get sub_spplier data as object
         */

        if (
          currentSubTier &&
          typeof currentSubTier === "object" &&
          Object.keys(currentSubTier).length > 0
        ) {
          Object.keys(currentSubTier).forEach((key) => {
            /**
             * Here "key" represent the sub-tier id
             */
            const subTierId = key;

            /**
             * Items means each sub-tier sub-supplier list
             */
            const items = currentSubTier[key];

            if (key && items && Array.isArray(items) && items.length > 0) {
              items.forEach((subSupplier) => {
                /**
                 * If a forwarder is present, do not show the forwarder's own address.
                 * Only show the ports.
                 */
                if (
                  orderDetailsData.forwarder &&
                  subSupplier.id === orderDetailsData.forwarder.sub_supplier_id
                )
                  return;
                /**
                 * Check if the item is is allready in the prepared list or not
                 */
                const findedItem = myPreaparedData.find(
                  (preparedItem) => preparedItem?.sub_supplier?.id === subSupplier?.id,
                );

                /**
                 * find the subtier from the list
                 *
                 * */
                const findedSubTier = subTierList.find((item) => item.id === parseInt(subTierId));

                /**
                 * Find the documents details using sub-supplier id and sub-tier id
                 */
                const findDocuments = documents?.find(
                  (doc) =>
                    parseInt(doc?.sub_supplier_id) === subSupplier?.id &&
                    parseInt(doc?.sub_tier_id) === parseInt(subTierId),
                );

                /**
                 * To avoid duplication in map we took the supplier as unique
                 * A supplier can do multiple task or job like washing, printing.
                 * In map we will show multiple for each supplier multiple task.
                 *
                 * ! When we found
                 * On found we just add the sub-tier item to the subtier list.
                 *
                 * !When not found
                 * Create a new items
                 */

                if (findedItem) {
                  findedItem.sub_tier.push({
                    ...findedSubTier,
                    arrive_date: findDocuments?.arrive_date,
                    dispatch_date: findDocuments?.dispatch_date,
                    quantity: findDocuments?.quantity,
                  });
                } else {
                  myPreaparedData.push({
                    address: subSupplier?.address,
                    sub_supplier: subSupplier,
                    sub_tier: [
                      {
                        ...findedSubTier,
                        arrive_date: findDocuments?.arrive_date,
                        dispatch_date: findDocuments?.dispatch_date,
                        quantity: findDocuments?.quantity,
                      },
                    ],
                  });
                }
              });
            }
          });
        }

        //supplier
        /**
         * ! Until confirmation do not remove bellow code
         * ! Old Method
         * Here is the parrtern to prepare data if we get sub_spplier data as array
         */
        if (
          currentSubTierSupplier &&
          Array.isArray(currentSubTierSupplier) &&
          currentSubTierSupplier.length > 0
        ) {
          currentSubTierSupplier?.forEach((item) => {
            const findedItem = myPreaparedData?.find(
              (preparedItem) => preparedItem?.supplier?.id === item?.supplier?.id,
            );

            if (
              orderDetailsData.forwarder &&
              item?.supplier?.id === orderDetailsData.forwarder.supplier_id
            )
              return;

            const findDocuments = documents?.find(
              (doc) =>
                parseInt(doc?.supplier_id) === item?.supplier?.id &&
                parseInt(doc?.sub_tier_id) === item?.sub_tier?.id,
            );

            if (findedItem) {
              findedItem.sub_tier.push({
                ...item?.sub_tier,
                arrive_date: findDocuments?.arrive_date,
                dispatch_date: findDocuments?.dispatch_date,
                quantity: findDocuments?.quantity,
              });
            } else {
              myPreaparedData.push({
                address: item?.supplier?.address,
                sub_supplier: item?.supplier,
                sub_tier: [
                  {
                    ...item?.sub_tier,
                    arrive_date: findDocuments?.arrive_date,
                    dispatch_date: findDocuments?.dispatch_date,
                    quantity: findDocuments?.quantity,
                  },
                ],
              });
            }
          });
        }

        /**
         * ! Until confirmation do not remove bellow code
         * ! New Method==
         * Here is the parrtern to prepare data if we get sub_spplier data as object
         */

        if (
          currentSubTierSupplier &&
          typeof currentSubTierSupplier === "object" &&
          Object.keys(currentSubTierSupplier).length > 0
        ) {
          Object.keys(currentSubTierSupplier).forEach((key) => {
            /**
             * Here "key" represent the sub-tier id
             */
            const subTierId = key;

            /**
             * Items means each sub-tier sub-supplier list
             */
            const items = currentSubTierSupplier[key];

            if (key && items && Array.isArray(items) && items.length > 0) {
              items.forEach((subSupplier) => {
                /**
                 * If a forwarder is present, do not show the forwarder's own address.
                 * Only show the ports.
                 */
                if (
                  orderDetailsData.forwarder &&
                  subSupplier.id === orderDetailsData.forwarder.supplier_id
                )
                  return;
                /**
                 * Check if the item is is allready in the prepared list or not
                 */
                const findedItem = myPreaparedData.find(
                  (preparedItem) => preparedItem?.supplier?.id === subSupplier?.id,
                );

                /**
                 * find the subtier from the list
                 *
                 * */
                const findedSubTier = subTierList.find((item) => item.id === parseInt(subTierId));

                /**
                 * Find the documents details using sub-supplier id and sub-tier id
                 */
                const findDocuments = documents?.find(
                  (doc) =>
                    parseInt(doc?.supplier_id) === subSupplier?.id &&
                    parseInt(doc?.sub_tier_id) === parseInt(subTierId),
                );

                /**
                 * To avoid duplication in map we took the supplier as unique
                 * A supplier can do multiple task or job like washing, printing.
                 * In map we will show multiple for each supplier multiple task.
                 *
                 * ! When we found
                 * On found we just add the sub-tier item to the subtier list.
                 *
                 * !When not found
                 * Create a new items
                 */

                if (findedItem) {
                  findedItem.sub_tier.push({
                    ...findedSubTier,
                    arrive_date: findDocuments?.arrive_date,
                    dispatch_date: findDocuments?.dispatch_date,
                    quantity: findDocuments?.quantity,
                  });
                } else {
                  myPreaparedData.push({
                    address: subSupplier?.address,
                    sub_supplier: subSupplier,
                    sub_tier: [
                      {
                        ...findedSubTier,
                        arrive_date: findDocuments?.arrive_date,
                        dispatch_date: findDocuments?.dispatch_date,
                        quantity: findDocuments?.quantity,
                      },
                    ],
                  });
                }
              });
            }
          });
        }
      }
      if (myPreaparedData.length > 0) {
        setMyPreparedMapData(myPreaparedData);
      } else {
        setMyPreparedMapData([]);
      }
    } else {
      const findTiersSubtiers = orderDetailsData?.transparency[`${tier}_sub_suppliers`];
      const findTiersSubtiersSupplier = orderDetailsData?.transparency[`${tier}_suppliers`];
      /**
       * If there is no sub-supplier item get out from this condition ;)
       */
      if (!findTiersSubtiers) return;
      if (!findTiersSubtiersSupplier) return;
      /**
       * ! Until confirmation do not remove bellow code
       * ! Old Method
       * Here is the parrtern to prepare data if we get sub_spplier data as array
       */
      if (findTiersSubtiers && Array.isArray(findTiersSubtiers) && findTiersSubtiers.length > 0) {
        const myPreaparedSingleTierData = findTiersSubtiers?.reduce((acc, findTierSubtier) => {
          /**
           * acc is accumulator which reprsent all value
           * checked current item all-ready in accumulator
           */
          if (findTierSubtier?.sub_supplier?.id === orderDetailsData.forwarder.sub_supplier_id)
            return;
          const findedItem = acc?.find(
            (preparedItem) => preparedItem?.sub_supplier?.id === findTierSubtier?.sub_supplier?.id,
          );

          /**
           * Find the documents details using sub-supplier id and sub-tier id
           */

          const findDocuments = documents?.find(
            (doc) =>
              parseInt(doc?.sub_supplier_id) === findTierSubtier?.sub_supplier?.id &&
              parseInt(doc?.sub_tier_id) === findTierSubtier?.sub_tier?.id,
          );

          /**
           * To avoid duplication in map we took the supplier as unique
           * A supplier can do multiple task or job like washing, printing.
           * In map we will show multiple for each supplier multiple task.
           *
           * ! When we found
           * On found we just add the sub-tier item to the subtier list.
           *
           * !When not found
           * Create a new items
           */

          if (findedItem) {
            findedItem.sub_tier.push({
              ...findTierSubtier?.sub_tier,
              arrive_date: findDocuments?.arrive_date,
              dispatch_date: findDocuments?.dispatch_date,
              quantity: findDocuments?.quantity,
            });
          } else {
            acc.push({
              address: findTierSubtier?.sub_supplier?.address,
              sub_supplier: findTierSubtier?.sub_supplier,
              sub_tier: [
                {
                  ...findTierSubtier?.sub_tier,
                  arrive_date: findDocuments?.arrive_date,
                  dispatch_date: findDocuments?.dispatch_date,
                  quantity: findDocuments?.quantity,
                },
              ],
            });
          }

          return acc;
        }, []);

        // Set the prepared final value to state
        if (myPreaparedSingleTierData && myPreaparedSingleTierData.length > 0) {
          setMyPreparedMapData(myPreaparedSingleTierData);
        } else {
          setMyPreparedMapData([]);
        }
      }

      /**
       * ! Until confirmation do not remove bellow code
       * ! New Method
       * Here is the parrtern to prepare data if we get sub_spplier data as array
       */
      if (
        findTiersSubtiers &&
        typeof findTiersSubtiers === "object" &&
        Object.keys(findTiersSubtiers).length > 0
      ) {
        const myPreaparedSingleTierData = Object.entries(findTiersSubtiers).reduce(
          (acc, [subTierId, subSuppliers]) => {
            if (subSuppliers && Array.isArray(subSuppliers) && subSuppliers.length > 0) {
              subSuppliers.forEach((subSupplier) => {
                /**
                 * acc is accumulator which reprsent all value
                 * checked current item all-ready in accumulator
                 */
                if (subSupplier?.id === orderDetailsData.forwarder.sub_supplier_id) return;
                const findedItem = acc.find(
                  (preparedItem) => preparedItem?.sub_supplier?.id === subSupplier?.id,
                );

                /**
                 * Find the documents details using sub-supplier id and sub-tier id
                 */
                const findDocuments = documents?.find(
                  (doc) =>
                    parseInt(doc?.sub_supplier_id) === subSupplier?.id &&
                    parseInt(doc?.sub_tier_id) === parseInt(subTierId),
                );

                // find the subtier from the list
                const findedSubTier = subTierList.find((item) => item.id === parseInt(subTierId));

                /**
                 * To avoid duplication in map we took the supplier as unique
                 * A supplier can do multiple task or job like washing, printing.
                 * In map we will show multiple for each supplier multiple task.
                 *
                 * ! When we found
                 * On found we just add the sub-tier item to the subtier list.
                 *
                 * !When not found
                 * Create a new items
                 */
                if (findedItem) {
                  findedItem.sub_tier.push({
                    ...findedSubTier,
                    arrive_date: findDocuments?.arrive_date,
                    dispatch_date: findDocuments?.dispatch_date,
                    quantity: findDocuments?.quantity,
                  });
                } else {
                  acc.push({
                    address: subSupplier?.address,
                    sub_supplier: subSupplier,
                    sub_tier: [
                      {
                        ...findedSubTier,
                        arrive_date: findDocuments?.arrive_date,
                        dispatch_date: findDocuments?.dispatch_date,
                        quantity: findDocuments?.quantity,
                      },
                    ],
                  });
                }
              });
            }
            return acc;
          },
          [],
        );

        // Set the prepared final value to state
        if (myPreaparedSingleTierData && myPreaparedSingleTierData.length > 0) {
          setMyPreparedMapData(myPreaparedSingleTierData);
        } else {
          setMyPreparedMapData([]);
        }
      }

      //supplier

      /**
       * ! Until confirmation do not remove bellow code
       * ! Old Method
       * Here is the parrtern to prepare data if we get sub_spplier data as array
       */
      if (
        findTiersSubtiersSupplier &&
        Array.isArray(findTiersSubtiersSupplier) &&
        findTiersSubtiersSupplier.length > 0
      ) {
        const myPreaparedSingleTierData = findTiersSubtiersSupplier?.reduce(
          (acc, findTierSubtier) => {
            /**
             * acc is accumulator which reprsent all value
             * checked current item all-ready in accumulator
             */
            const findedItem = acc?.find(
              (preparedItem) => preparedItem?.supplier?.id === findTierSubtier?.supplier?.id,
            );

            /**
             * Find the documents details using sub-supplier id and sub-tier id
             */
            const findDocuments = documents?.find(
              (doc) =>
                parseInt(doc?.supplier_id) === findTierSubtier?.supplier?.id &&
                parseInt(doc?.sub_tier_id) === findTierSubtier?.sub_tier?.id,
            );

            /**
             * To avoid duplication in map we took the supplier as unique
             * A supplier can do multiple task or job like washing, printing.
             * In map we will show multiple for each supplier multiple task.
             *
             * ! When we found
             * On found we just add the sub-tier item to the subtier list.
             *
             * !When not found
             * Create a new items
             */

            if (findedItem) {
              findedItem.sub_tier.push({
                ...findTierSubtier?.sub_tier,
                arrive_date: findDocuments?.arrive_date,
                dispatch_date: findDocuments?.dispatch_date,
                quantity: findDocuments?.quantity,
              });
            } else {
              acc.push({
                address: findTierSubtier?.supplier?.address,
                sub_supplier: findTierSubtier?.supplier,
                sub_tier: [
                  {
                    ...findTierSubtier?.sub_tier,
                    arrive_date: findDocuments?.arrive_date,
                    dispatch_date: findDocuments?.dispatch_date,
                    quantity: findDocuments?.quantity,
                  },
                ],
              });
            }

            return acc;
          },
          [],
        );

        // Set the prepared final value to state
        if (myPreaparedSingleTierData && myPreaparedSingleTierData.length > 0) {
          setMyPreparedMapData(myPreaparedSingleTierData);
        } else {
          setMyPreparedMapData([]);
        }
      }

      /**
       * ! Until confirmation do not remove bellow code
       * ! New Method
       * Here is the parrtern to prepare data if we get sub_spplier data as array
       */
      if (
        findTiersSubtiersSupplier &&
        typeof findTiersSubtiersSupplier === "object" &&
        Object.keys(findTiersSubtiersSupplier).length > 0
      ) {
        const myPreaparedSingleTierData = Object.entries(findTiersSubtiersSupplier).reduce(
          (acc, [subTierId, subSuppliers]) => {
            if (subSuppliers && Array.isArray(subSuppliers) && subSuppliers.length > 0) {
              subSuppliers.forEach((subSupplier) => {
                /**
                 * acc is accumulator which reprsent all value
                 * checked current item all-ready in accumulator
                 */
                const findedItem = acc.find(
                  (preparedItem) => preparedItem?.supplier?.id === subSupplier?.id,
                );

                /**
                 * Find the documents details using sub-supplier id and sub-tier id
                 */
                const findDocuments = documents?.find(
                  (doc) =>
                    parseInt(doc?.supplier_id) === subSupplier?.id &&
                    parseInt(doc?.sub_tier_id) === parseInt(subTierId),
                );

                // find the subtier from the list
                const findedSubTier = subTierList.find((item) => item.id === parseInt(subTierId));
                /**
                 * To avoid duplication in map we took the supplier as unique
                 * A supplier can do multiple task or job like washing, printing.
                 * In map we will show multiple for each supplier multiple task.
                 *
                 * ! When we found
                 * On found we just add the sub-tier item to the subtier list.
                 *
                 * !When not found
                 * Create a new items
                 */
                if (findedItem) {
                  findedItem.sub_tier.push({
                    ...findedSubTier,
                    arrive_date: findDocuments?.arrive_date,
                    dispatch_date: findDocuments?.dispatch_date,
                    quantity: findDocuments?.quantity,
                  });
                } else {
                  acc.push({
                    address: subSupplier?.address,
                    sub_supplier: subSupplier,
                    sub_tier: [
                      {
                        ...findedSubTier,
                        arrive_date: findDocuments?.arrive_date,
                        dispatch_date: findDocuments?.dispatch_date,
                        quantity: findDocuments?.quantity,
                      },
                    ],
                  });
                }
              });
            }
            return acc;
          },
          [],
        );

        // Set the prepared final value to state
        if (myPreaparedSingleTierData && myPreaparedSingleTierData.length > 0) {
          setMyPreparedMapData(myPreaparedSingleTierData);
        } else {
          setMyPreparedMapData([]);
        }
      }
    }
  };

  useEffect(() => {
    preparedData(selectedPackage);
  }, [orderDetailsData, orderId]);

  // check that user.workspace_type is retailer then isDrawerOpen should be false
  useEffect(() => {
    if (user?.workspace_type === "retailer") {
      setIsDrawerOpen(false);
    }
  }, [user]);

  return (
    <div
      className="relative w-full overflow-y-auto bg-global-white flex-1 rounded-[16px]"
      style={{
        border: isDesktop ? "16px solid #FFF" : "8px solid #FFF",
      }}
    >
      <div className="flex flex-col ">
        <div className="absolute left-2 right-2 top-2 md:left-6 md:top-6 md:right-6 ">
          <div className="flex gap-4 md:gap-6 overflow-x-auto">
            <Card
              size="sm"
              className="bg-white  h-[106px] pt-5 pl-5 pr-[14px] pb-[17px] rounded-xl border border-[#E9EAEB] gap-2 !shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05) z-[9]"
            >
              <div className="flex  justify-start items-center w-[200px]  md:w-[252px]">
                <div className="w-full">
                  <div className="text-sm leading-5 font-medium text-card-small-title whitespace-nowrap">
                    Transparency Score{" "}
                  </div>
                  <div className=" text-xl md:text-3xl font-semibold leading-[38px] text-global-title-3 ">{`${orderDetailsData?.transparency?.total_score ? orderDetailsData?.transparency?.total_score : 0}%`}</div>
                </div>
                <div className="sticky top-0">
                  <CircleProgressBar
                    currentProgress={
                      orderDetailsData?.transparency?.total_score
                        ? orderDetailsData?.transparency?.total_score
                        : 0
                    }
                    size={isDesktop ? 17.25 : 14.25}
                    strokeColorVariable={transpercencyLineProgressPercentageColors(
                      `${orderDetailsData?.transparency?.total_score ? orderDetailsData?.transparency?.total_score : 0}`,
                    )}
                  />
                </div>
              </div>
            </Card>
            <Card
              size="sm"
              className="bg-white  h-[106px] pt-5 pl-5 pr-[14px] pb-[17px] rounded-xl border border-[#E9EAEB] gap-2 !shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05) z-[9]"
            >
              <div className="flex  justify-start items-center w-[200px]  md:w-[252px]">
                <div className="w-full">
                  <div className="text-sm leading-5 font-medium text-card-small-title whitespace-nowrap">
                    Verification Score
                  </div>
                  <div className=" text-xl md:text-3xl font-semibold leading-[38px] text-global-title-3 ">{`${orderDetailsData?.transparency?.total_verification_score ? orderDetailsData?.transparency?.total_verification_score : 0}%`}</div>
                </div>
                <div className="sticky top-0">
                  <CircleProgressBar
                    currentProgress={
                      orderDetailsData?.transparency?.total_verification_score
                        ? orderDetailsData?.transparency?.total_verification_score
                        : 0
                    }
                    size={isDesktop ? 17.25 : 14.25}
                    strokeColorVariable="--color-progress-surface-blue"
                  />
                </div>
              </div>
            </Card>

            <Card
              size="sm"
              className="bg-white pt-5 pl-5 pr-[14px] pb-[17px] h-[106px]  rounded-xl border border-[#E9EAEB] !shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05) z-[9]"
            >
              <div className="flex flex-col w-[200px] md:w-[252px]  justify-start items-start ">
                <div className="text-sm leading-5 font-medium text-[#535862] text-start whitespace-nowrap">
                  Linked Tiers
                </div>

                <div className="text-global-title-3 leading-[38px] font-semibold text-xl md:text-3xl">
                  {orderDetailsData?.tier_totals?.total_linked_tiers ?? 0}
                  <span className="text-xl md:text-2xl">
                    /{orderDetailsData?.tier_totals?.total_tiers ?? 0}
                  </span>
                </div>
              </div>
            </Card>
          </div>
        </div>
        <div
          className="relative w-full h-[685px]"
          style={{
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          }}
        >
          {myPreparedMapData && (
            <MapView details={myPreparedMapData} locationFrom="orders" orderId={orderId} />
          )}
        </div>

        <div
          className={`absolute bottom-0 left-2 right-2 md:left-6 md:right-6 bg-global-theme z-[9] transition-all duration-500 ease-in-out border border-border-secondary ${
            isDrawerOpen ? "h-[528px]" : "h-[59px]"
          }`}
          style={{
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            boxShadow: "0px 1px 2px 0px rgba(10, 13, 18, 0.05)",
            overflow: "hidden",
          }}
        >
          {/* Optional: Mini Handle inside drawer too */}
          <div className="relative">
            <div className="w-full flex justify-center">
              <div
                onClick={() => setIsDrawerOpen(!isDrawerOpen)}
                className={`w-10 flex justify-center  cursor-pointer ${isDrawerOpen ? "pt-4 pb-5" : "py-2"}`}
              >
                <div className="w-10 h-1 bg-[#475467BF] rounded-full"></div>
              </div>
            </div>
            {isDrawerOpen && (
              <div className="absolute top-[13px] right-[13px]">
                <XCircleCrossIcon
                  onClick={() => setIsDrawerOpen(false)}
                  className="cursor-pointer"
                />
              </div>
            )}
          </div>

          {/* Drawer content only visible when open */}
          <div className="overflow-y-auto h-[calc(528px-59px)]">
            {orderDetailsData && <UpdateSupplyChainCard refetchOrderDetails={refetch} />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderMapCard;
